"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderRadius: '3px',
    textTransform: 'none',
    fontFamily: _theme.default.typography.proxima.regular,
    cursor: 'pointer',
    textRendering: 'geometricPrecision',
    [_theme.default.breakpoints.up('xs')]: {
      padding: '0px 20px 0px 20px',
      width: '100%',
      height: '50px',
      fontSize: '18px !important'
    },
    [_theme.default.breakpoints.up('sm')]: {
      padding: '0px 30px 0px 30px',
      width: 'auto',
      height: '40px',
      fontSize: '15px !important'
    },
    [_theme.default.breakpoints.up('md')]: {
      width: 'auto',
      height: '40px',
      fontSize: '15px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      width: 'auto',
      height: '50px',
      fontSize: '18px !important'
    },
    '&:hover': {
      boxShadow: 'none'
    },
    '&.MuiButton-containedPrimary': {
      color: _theme.default.palette.white,
      marginLeft: 'auto',
      fontFamily: _theme.default.typography.proxima.semiBold,
      backgroundColor: _theme.default.palette.primary.light,
      '&:hover': {
        backgroundColor: _theme.default.palette.primary.neutral
      }
    },
    '&.cancelButton, &.doneButton': {
      minWidth: 'unset'
    },
    '&.cancelButton': {
      letterSpacing: 0,
      color: _theme.default.palette.primary.light,
      fontFamily: _theme.default.typography.proxima.regular,
      background: 'transparent',
      textTransform: 'initial',
      marginLeft: 'auto',
      [_theme.default.breakpoints.up('xs')]: {
        fontSize: '16px !important'
      },
      [_theme.default.breakpoints.up('sm')]: {
        fontSize: '14px !important'
      },
      [_theme.default.breakpoints.up('md')]: {
        fontSize: '14px !important'
      },
      [_theme.default.breakpoints.up('lg')]: {
        fontSize: '16px !important'
      }
    },
    '&.Mui-disabled': {
      color: _theme.default.palette.white,
      backgroundColor: _theme.default.palette.grayScale.main,
      '&:hover, &:focus': {
        backgroundColor: _theme.default.palette.grayScale.main
      }
    }
  }
});
var _default = exports.default = useStyles;